import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var FlaskRound = createReactComponent("FlaskRound", ["svg", defaultAttributes, [["path", {
  d: "M10 2v7.31",
  key: "zu6ln6"
}], ["path", {
  d: "M14 9.3V1.99",
  key: "unm02s"
}], ["path", {
  d: "M8.5 2h7",
  key: "j9cflu"
}], ["path", {
  d: "M14 9.3a6.5 6.5 0 11-4 0",
  key: "1g5fut"
}], ["path", {
  d: "M5.58 16.5h12.85",
  key: "1aaksh"
}]]]);
export default FlaskRound;